module.exports = __webpack_public_path__ + "static/media/background-2-634w.ce68fd9a.webp";